import { HttpRequest } from '@angular/common/http';

/**
 * URLs that should not trigger the loader
 */
const LOADER_SKIP_URLS = ['update-fcm-token'];

/**
 * Request methods that should not trigger the loader
 */
const LOADER_SKIP_METHODS: string | string[] = [
  // Add methods if needed, e.g., 'HEAD', 'OPTIONS'
];

/**
 * Determines if loader should be skipped for the given request
 */
export function shouldSkipLoader(request: HttpRequest<unknown>): boolean {
  // Skip for specific URLs
  if (LOADER_SKIP_URLS.some(skipUrl => request.url.includes(skipUrl))) {
    return true;
  }

  // Skip for specific methods
  if (LOADER_SKIP_METHODS.includes(request.method)) {
    return true;
  }

  // Skip for requests marked with custom header
  if (request.headers.has('X-Skip-Loader')) {
    return true;
  }

  return false;
}
